import React from 'react';
import PropTypes from 'prop-types';

import { EyeOnChunky } from '@eb/eds-iconography';
import { EyeOffChunky } from '@eb/eds-iconography';

export const PASSWORD_VISIBLE_ICON = <EyeOnChunky />;
export const PASSWORD_HIDDEN_ICON = <EyeOffChunky />;

export const PASSWORD_ICON_TYPES = PropTypes.oneOf([
    PASSWORD_VISIBLE_ICON,
    PASSWORD_HIDDEN_ICON,
]);
